import React from "react";
import Rating from "react-rating";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { openAPI } from "../../../../config";

class TestimonialPopup extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      content_type: 1,
      content: -1,
      score: 0,
      success: -1,
      testimonialData: {},
    };
    this.rateContent = this.rateContent.bind(this);
    this.escFunction = this.escFunction.bind(this);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  UNSAFE_componentWillMount() {
    this._isMounted = true;
    this.setState({
      testimonialData: this.props.testimonialDataForPopUp,
    });

    document.addEventListener("keydown", this.escFunction, false);
  }

  rateContent = () => {
    if (this.state.score > 0) {
      openAPI
        .post(
          `${process.env.REACT_APP_API_URL}/rating`,
          {
            content_type: 1,
            content: this.state.content,
            score: this.state.score,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (this._isMounted) {
            this.setState({ ...response.data });
          }
        });
    }
  };

  escFunction = (event) => {
    if (event.keyCode === 27) {
      if (this.props.isDataFromProps) {
        this.props.setPopUpFalse({
          toLocation: this.props.testimonialDataForPopUp.toLocation,
        });
        // this.props.history.push(
        //   `${this.props.vendorVideosFromProfile.toLocation}`
        // );
      }
    }
  };

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  render() {
    return (
      <>
        <section class="overlay_popup clsOverlayPopup" aria-hidden="false">
          <div class="popBox">
            <div class="top_header">
              <h1>{`${
                !!this.props.companyName
                  ? this.props.companyName
                  : !!this.props?.testimonialDataForPopUp?.vendor?.name
                  ? this.props?.testimonialDataForPopUp?.vendor?.name
                  : ``
              } Testimonial`}</h1>
              <a
                href="#"
                class="close-overlay"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (this.props.isDataFromProps) {
                    this.props.setPopUpFalse({
                      toLocation: this.props.testimonialDataForPopUp.toLocation,
                    });
                    // this.props.history.push(
                    //   `${this.props.vendorVideosFromProfile.toLocation}`
                    // );
                  }
                }}
              >
                Close
              </a>
            </div>

            <div class="popup_overlay_screen">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="popup_content_box">
                    <div class="userDetails">
                      <span class="name">
                        {this.state.testimonialData &&
                        this.state.testimonialData.contactdetail
                          ? this.state.testimonialData.contactdetail.name
                          : ""}
                      </span>
                      <span class="desgn">
                        {this.state.testimonialData &&
                        this.state.testimonialData.contactdetail
                          ? this.state.testimonialData.contactdetail.jobtitle
                          : ""}
                      </span>
                      <div class="logo">
                        <img
                          src={this.state.testimonialData.customer_logo}
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="text_block">
                      <p>
                        “
                        {this.state.testimonialData &&
                          this.state.testimonialData.body &&
                          this.state.testimonialData.body
                            .replace(/"/g, "")
                            .replace(/[“”]/g, "")}
                        ”
                      </p>
                    </div>
                  </div>
                  <div class="clsOverlayPopupFooter">
                    <div class="container">
                      {Number(this.state.success) === -1 ? (
                        <div class="rate_this">
                          <div class="left_section">
                            <h2>Rate This Customer Testimonial</h2>
                            <p>
                              Your vote helps our customer references be more
                              accurate and useful
                            </p>
                          </div>
                          <div class="right_section">
                            <div class="star" id="uw58f2b3e">
                              <div class="star-rating">
                                <div
                                  aria-label={`rate ${this.props.companyName} testimonial`}
                                >
                                  <input
                                    type="radio"
                                    name="rating"
                                    id="rating1"
                                    value="1"
                                    aria-label="star rating 1"
                                    checked={
                                      this.state.score === 1 ? "checked" : ""
                                    }
                                    aria-checked={
                                      this.state.score === 1 ? true : false
                                    }
                                  />
                                  <label
                                    htmlFor="rating1"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.setState({
                                        score: 1,
                                        content: this.state.testimonialData.id,
                                      });
                                    }}
                                    aria-label="star rating 1"
                                    aria-checked={
                                      this.state.score === 1 ? true : false
                                    }
                                  >
                                    <span>1</span>
                                  </label>
                                  <input
                                    type="radio"
                                    name="rating"
                                    value="2"
                                    id="rating2"
                                    aria-label="star rating 2"
                                    checked={
                                      this.state.score === 2 ? "checked" : ""
                                    }
                                    aria-checked={
                                      this.state.score === 2 ? true : false
                                    }
                                  />
                                  <label
                                    htmlFor="rating2"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.setState({
                                        score: 2,
                                        content: this.state.testimonialData.id,
                                      });
                                    }}
                                    aria-label="star rating 2"
                                    aria-checked={
                                      this.state.score === 2 ? true : false
                                    }
                                  >
                                    <span>2</span>
                                  </label>
                                  <input
                                    type="radio"
                                    name="rating"
                                    value="3"
                                    id="rating3"
                                    aria-label="star rating 3"
                                    checked={
                                      this.state.score === 3 ? "checked" : ""
                                    }
                                    aria-checked={
                                      this.state.score === 3 ? true : false
                                    }
                                  />
                                  <label
                                    htmlFor="rating3"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.setState({
                                        score: 3,
                                        content: this.state.testimonialData.id,
                                      });
                                    }}
                                    aria-label="star rating 3"
                                    aria-checked={
                                      this.state.score === 3 ? true : false
                                    }
                                  >
                                    <span>3</span>
                                  </label>
                                  <input
                                    type="radio"
                                    name="rating"
                                    value="4"
                                    id="rating4"
                                    aria-label="star rating 4"
                                    checked={
                                      this.state.score === 4 ? "checked" : ""
                                    }
                                    aria-checked={
                                      this.state.score === 4 ? true : false
                                    }
                                  />
                                  <label
                                    htmlFor="rating4"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.setState({
                                        score: 4,
                                        content: this.state.testimonialData.id,
                                      });
                                    }}
                                    aria-label="star rating 4"
                                    aria-checked={
                                      this.state.score === 4 ? true : false
                                    }
                                  >
                                    <span>4</span>
                                  </label>
                                  <input
                                    type="radio"
                                    name="rating"
                                    value="5"
                                    id="rating5"
                                    aria-label="star rating 5"
                                    checked={
                                      this.state.score === 5 ? "checked" : ""
                                    }
                                    aria-checked={
                                      this.state.score === 5 ? true : false
                                    }
                                  />
                                  <label
                                    htmlFor="rating5"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.setState({
                                        score: 5,
                                        content: this.state.testimonialData.id,
                                      });
                                    }}
                                    aria-label="star rating 5"
                                    aria-checked={
                                      this.state.score === 5 ? true : false
                                    }
                                  >
                                    <span>5</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <input
                              type="button"
                              value="Submit"
                              data-uw-rm-form="fx"
                              aria-labelledby="uw58f2b3e"
                              onClick={(e) => {
                                e.preventDefault();
                                this.rateContent();
                              }}
                            />
                          </div>
                        </div>
                      ) : null}
                      <div class="clsMsg">
                        {Number(this.state.success) === 1 ? (
                          <div className="success_msg">
                            <span className="success">
                              <i className="fa fa-check" aria-hidden="true"></i>{" "}
                              Rating Saved!
                            </span>
                            <p>Thank you for your feedback!</p>
                          </div>
                        ) : null}
                        {Number(this.state.success) === 0 ? (
                          <div className="failure_msg">
                            <span className="failure">
                              <i
                                className="fa fa-exclamation-triangle"
                                aria-hidden="true"
                              ></i>{" "}
                              Rating Could not be Saved!
                            </span>
                            <p>There was an error, please try again.</p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    companyName: state.vendorCommon.name,
  };
};

const WithRouterTestimonialPopup = withRouter(TestimonialPopup);

export default connect(mapStateToProps)(WithRouterTestimonialPopup);
